import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import useAPIClient, { APIClient } from './useAPIClient';

const useAPIMutation = <TData, TVariables, TContext>(
  mutationFn: (variables: TVariables, api: APIClient) => Promise<TData>,
  options?: Omit<UseMutationOptions<TData, AxiosError, TVariables, TContext>, 'mutationFn'>
) => {
  const client = useAPIClient();

  return useMutation<TData, AxiosError, TVariables, TContext>(
    (variables: TVariables) => mutationFn(variables, client),
    options
  );
};

export default useAPIMutation;
